export enum ValidationTaxIdStatus {
  INVALID = 'invalid_taxid',
}
